import { InputProps } from "@/hooks/useInput";

const HelperText = (props: Pick<InputProps, 'helperText'>) => {
  if (!props.helperText) return null;

  return (
    <div className="" slot="description">
      <span className="mt-2 text-sm text-gray-500 dark:text-gray-400">
        {props.helperText}
      </span>
    </div>
  );
};

export default HelperText;
